module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp13_7042.c3604a8b.png";